import React, { useState, useEffect } from "react";
import { DownOutlined } from "@ant-design/icons";
import { Dropdown, Menu } from "antd";
import type { MenuProps } from "antd";
import { CreativeType, DisplayBannerT } from "types/creative";
import { useAppState, useAppDispatch } from "context";
import { setBannerActive } from "context/actions";

import "./BannerMenu.scss";

const baseList = [
  {
    key: "1",
    label: "300x250",
    width: 300,
    height: 250,
    disabled: true,
  },
  {
    key: "2",
    label: "300x600",
    width: 300,
    height: 600,
    disabled: true,
  },
  {
    key: "3",
    label: "970x250",
    width: 970,
    height: 250,
    disabled: true,
  },
];

// TODO, add sub category when image playback
const playbackOptions = {
  1: [],
  2: [1,2,3],
  3: [],
  4: [2],
  5: [],
  6: [1,2,3],
  7: []
}


const BannerMenu = () => {
  const dispatch = useAppDispatch();
  const {
    creative = {} as CreativeType,
    displayBanner = {} as DisplayBannerT,
  } = useAppState();
  const { active, size } = displayBanner;
  const { playback_id } = creative;
  const [ currentSelected, setCurrentSelected] = useState('1');

  const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    const firstActive = menu.props.items.find(i => i.disabled === false);
    const width = firstActive.width;
    const height = firstActive.height;
    setCurrentSelected(firstActive.key)
    
    dispatch(
      setBannerActive({
        ...displayBanner,
        active: !active,
        size: { width, height }
      })
    );
  };

  const onOptionClick: MenuProps["onClick"] = ({ key }) => {
    const idx = parseInt(key, 10);
    const width = baseList[idx - 1].width;
    const height = baseList[idx - 1].height;
    setCurrentSelected(key)
    dispatch(
      setBannerActive({
        ...displayBanner,
        active: true,
        size: { width, height },
      })
    );
  };

  const validateSizes = (list) => {
    const newList = list.map((item) => {
      const src = playbackOptions[playback_id];
      if(src.includes(parseInt(item.key, 10))) {
        item.disabled = false;
      }
      return item;
    });

    return <Menu items={[...newList]} onClick={onOptionClick} activeKey={currentSelected}/>;
  };
  const [menu, setMenu] = useState(validateSizes(baseList));


  useEffect(() => {
    const m = validateSizes(baseList);
    setMenu(m);
  }, [creative.id, size.width, size.height]);

  return (
    <div className={`banner-options ${active ? "banner-view-wrapper" : ""}`}>
      <Dropdown.Button
        onClick={handleButtonClick}
        overlay={menu}
        icon={<DownOutlined />}
      >
        {active ? "Disable Banner" : "View Banner"}
      </Dropdown.Button>
    </div>
  );
};

export default BannerMenu;
